"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;
exports.getPageTypeStringValue = getPageTypeStringValue;

var _common = require("../../generated-src/snapchat/web/stories/common");

var Status;
exports.Status = Status;

(function (Status) {
  Status[Status["Ok"] = 0] = "Ok";
  Status[Status["BadRequest"] = 1] = "BadRequest";
  Status[Status["NotFound"] = 2] = "NotFound";
  Status[Status["Unavailable"] = 3] = "Unavailable";
  Status[Status["Unauthorized"] = 4] = "Unauthorized";
  Status[Status["UriTooLong"] = 5] = "UriTooLong";
})(Status || (exports.Status = Status = {}));

// in some cases, we get the pageType as a number rather than the literal string/enum -
// let's always check this to avoid errors
function getPageTypeStringValue(pageType) {
  if (typeof pageType === "number") {
    var pageTypeValue = _common.PageType[pageType];
    return pageTypeValue ? pageTypeValue.toString() : _common.PageType.UNSET.toString();
  } // it's the literal enum, we can just return


  if (typeof pageType === "string") {
    return pageType;
  }

  return _common.PageType.UNSET.toString();
}